import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

export const USE_FIREBASE = true;

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
}

let app, auth, db

if (USE_FIREBASE) {
  try {
    app = initializeApp(firebaseConfig)
    auth = getAuth(app)
    db = getFirestore(app)
  } catch (error) {
    console.error('Firebase initialization error:', error)
  }
} else {
  auth = { currentUser: { uid: "dev-user", email: "dev@test.com" } }
  db = {}
}

export function initializeFirebase() {
  if (USE_FIREBASE) {
    try {
      if (!app) {
        app = initializeApp(firebaseConfig)
        auth = getAuth(app)
        db = getFirestore(app)
      }
    } catch (error) {
      console.error('Firebase initialization error:', error)
    }
  }
}

export { auth, db }